import { Component } from '@angular/core';

@Component({
  selector: 'app-create-alert-progress-modal',
  templateUrl: './create-alert-progress-modal.component.html',
  styleUrls: ['./create-alert-progress-modal.component.scss']
})
export class CreateAlertProgressModalComponent  {

  constructor() { }

  

}
